import { Styles } from "../../../config"

export default {
	container: {
		boxSizing: "border-box",
		width: "100%",
		maxWidth: "900px",
		justifyContent: "center",
		alignItems: "center",

		"*": {
			boxSizing: "border-box"
		}
	},

	banner({ color }) {
		return {
			boxSizing: "border-box",
			width: "100%",
			padding: { zero: "10px", xs2: "15px" },
			justifyContent: "center",
			alignItems: "center",
			background: Styles.Color?.[color],
			borderRadius: "10px"
		}
	},

	text: {
		fontSize: { zero: "1rem", xs2: "1.4rem" },
		fontWeight: "600",
		color: Styles.Color.white,
		textAlign: "center"
	}
}
